import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, Observable, Subject, takeUntil } from 'rxjs';
import { ACCOUNT_TYPE } from 'src/app/core/domain';
import { IProfileDetails } from 'src/app/core/domain/profile.model';
import { IGlobalSettings } from 'src/app/core/domain/settings.model';
import { IWishlistItem } from 'src/app/core/domain/wishlist.model';
import { GlobalService } from 'src/app/core/service/global.service';
import { ProfileService } from 'src/app/core/service/profile.service';
import { getGlobalSettings } from 'src/app/core/state/global';
import { getProfileData } from 'src/app/core/state/profile';

@Component({
  selector: 'app-wishlist-modal',
  templateUrl: './wishlist-modal.component.html',
  styleUrls: ['./wishlist-modal.component.scss']
})
export class WishlistModalComponent implements OnInit {

  wishlistItems: IWishlistItem[] = []
  loader = false
  profileData: IProfileDetails;
  public globalSettings$: Observable<IGlobalSettings>;
  globalSettings: IGlobalSettings;
  private destroyed$: Subject<void> = new Subject();
  @Input('modalRef') modalRef: NgbModalRef;
  @Input('accountType') accountType: ACCOUNT_TYPE;

  constructor(
    public globalService: GlobalService, private store: Store,
    private profileService: ProfileService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.globalSettings$ = this.store.pipe(select(getGlobalSettings));
    this.setGlobalSettings()

    this.store.pipe(select(getProfileData))
      .pipe(distinctUntilChanged()).subscribe((res) => {
        if (res) {
          this.profileData = res;
          this.fetchWishList()
        }
      })

    this.fetchWishList()
  }

  fetchWishList() {
    if (!this.profileData) {
      return
    }
    this.globalService.getAllWhishlist({
      toUserUUID: this.profileData.id + '',
      // userAccountType: this.userAccountType
    }).subscribe(res => {
      if (res.data) {
        this.wishlistItems = res.data
        if(this.accountType) {
          this.wishlistItems = this.wishlistItems.filter(e=>e.otherUserAccountType === this.accountType)
        }
        // const items = res.data.filter(e => e.otherUser.uuid === this.toUserUUID)
        // console.log('wishlist', items)
        // this.connectionItem = items?.[0]
      }
    })
  }


  setGlobalSettings(): void {
    this.globalSettings$.pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((res) => {
      if (res) {
        {
          this.globalSettings = res;
        }
      }
    });
  }

  getS3ConnectionAvatarUrl = (avatarUrl: string): string => {
    if (this.globalSettings?.s3Url) {
      return this.globalSettings.imgKitUrl + avatarUrl + '?tr=w-100,h-100';
    } else {
      return avatarUrl;
    }
  }


  openProfilePage(item: IWishlistItem) {
    const link = this.profileService.getProfileLink(
      item.companyUUID,
      item.companyName,
      item.otherUserAccountType
    )
    // this.router.navigate([link]);
    const url = this.router.serializeUrl(this.router.createUrlTree([link]));
    window.open(url, '_blank');


    // this.modalRef.close()
  }

}
